import { render, staticRenderFns } from "./QRCode.vue?vue&type=template&id=46e3c968"
import script from "./qRCode.js?vue&type=script&lang=js&external"
export * from "./qRCode.js?vue&type=script&lang=js&external"
import style0 from "./QRCode.vue?vue&type=style&index=0&id=46e3c968&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('46e3c968')) {
      api.createRecord('46e3c968', component.options)
    } else {
      api.reload('46e3c968', component.options)
    }
    module.hot.accept("./QRCode.vue?vue&type=template&id=46e3c968", function () {
      api.rerender('46e3c968', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/vue-qrcode/QRCode.vue"
export default component.exports